// @internal
import './number-operations';

let headers: any = {};

// Overrules all AJAX calls globally, regardless of which library is behind the request.

let open = XMLHttpRequest.prototype.open;
let send = XMLHttpRequest.prototype.send;
let setRequestHeader = XMLHttpRequest.prototype.setRequestHeader;

// Simple cookie implementation to avoid conflicts with other libraries.
let getCookie = function (name: string)
{
	let nameEQ = name + '=';
	let ca = document.cookie.split(';');
	let c;

	for (let i = 0; i < ca.length; i++)
	{
		c = ca[i];
		while (c.charAt(0) === ' ')
		{
			c = c.substring(1, c.length);
		}
		if (c.indexOf(nameEQ) === 0)
		{
			return c.substring(nameEQ.length, c.length);
		}
	}

	return null;
};

XMLHttpRequest.prototype.setRequestHeader = function (key, value)
{
	if (!this._headers)
	{
		this._headers = {};
	}
	this._headers[key] = value;

	return setRequestHeader.apply(this, arguments);
};

XMLHttpRequest.prototype.open = function (method: string, url: string)
{
	this._url = url;
	if (!this._headers)
	{
		this._headers = {};
	}

	return open.apply(this, arguments);
};

XMLHttpRequest.prototype.send = function (data: any)
{
	if (!(/^http:.*/.test(this._url) || /^https:.*/.test(this._url)))
	{
		// Add X-Requested-With to all local URIs, if it was not added already.
		if (!this._headers['X-Requested-With'])
		{
			this.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
		}

		// Add X-XSRF-Token if provided as a cookie, if it was not added already.
		let token = getCookie('XSRF-TOKEN');

		if (token && !this._headers['X-XSRF-TOKEN'])
		{
			this.setRequestHeader('X-XSRF-TOKEN', token);
		}

		for (let key in headers)
		{
			this.setRequestHeader(key, typeof (headers[key]) == 'function' ? headers[key]() : headers[key]);
		}
	}

	return send.apply(this, arguments);
};

let _fetch = window.fetch;

(window as any).fetch = function(resource: RequestInfo, init?: RequestInit)
{
	const url = (resource instanceof Request) ? resource.url : resource;

	if (!(/^http:.*/.test(url) || /^https:.*/.test(url)))
	{
		const req = (resource instanceof Request) ? resource : (init ? init : {});
		let reqheaders: HeadersInit | string[][] | Record<string, string> | undefined = req.headers;

		if (!reqheaders)
		{
			reqheaders = new Headers();
		}

		if (reqheaders instanceof Array)
		{
			let h: Record<string, string> = {};

			for (let i = 0; i < reqheaders.length; i++)
			{
				h[reqheaders[i][0]] = reqheaders[i][1];
			}

			reqheaders = h;
		}

		if (!(reqheaders instanceof Headers))
		{
			let h = new Headers();

			for (let key in reqheaders)
			{
				h.set(key, reqheaders[key]);
			}

			reqheaders = h;
		}

		// Add X-Requested-With to all local URIs, if it was not added already.
		if (!reqheaders.has('X-Requested-With'))
		{
			reqheaders.set('X-Requested-With', 'Fetch');
		}

		// Add X-XSRF-Token if provided as a cookie, if it was not added already.
		let token = getCookie('XSRF-TOKEN');

		if (token && !reqheaders.has('X-XSRF-TOKEN'))
		{
			reqheaders.set('X-XSRF-TOKEN', token);
		}

		for (let key in headers)
		{
			reqheaders.set(key, typeof (headers[key]) == 'function' ? headers[key]() : headers[key]);
		}

		(req as any).headers = reqheaders;

		return (req instanceof Request) ? _fetch(req) : _fetch(resource, req);
	}
	else
	{
		return _fetch(resource, init);
	}
}

export function setGlobalAjaxHeader(key: string, value: string | Function): void
{
	if (value)
	{
		headers[key] = value;
	}
	else
	{
		headers[key] = undefined;
		delete headers[key];
	}
};